<template>
    <Head :title="'County Appraisal Offices information for Clay, Duval, and St Johns'" >
        <link rel="canonical" href="https://www.ginabetbeze.com/county-appraisals" />
        <meta name="description" content="Find information on County Appraisal Offices in Northeast Florida." />
    </Head>

    <PageContent
        :id="'county-appraisers-page'"
        :breadcrumbs="['Home','Resources','County Appraiser\'s Offices']"
        :header="'County Appraiser\'s Offices'"
    >
        <BasicContainer>
            <SecondaryHeader>Contact Information for County Appraisal Offices in Clay, Duval, and St Johns counties</SecondaryHeader>
            <Paragraph>
                The county Appraiser's Offices are responsible for assessing property values within the county, ensuring
                fair and equitable taxation. These offices provide detailed information on property assessments,
                appraisals, and tax-related inquiries, helping residents understand the value of their properties and
                their corresponding tax obligations. Check below for links to your county's appraisal offices
                information.
            </Paragraph>

            <SecondaryHeader id="stjohnscounty">St. Johns County Property Appraiser</SecondaryHeader>
            <Paragraph>
                <a class="flex items-center ml-4" href="https://www.sjcpa.gov/" target="_blank" rel="noreferrer">
                    St. Johns County Property Appraiser site
                    <ArrowTopRightOnSquareIcon class="h-4 w-4 ml-1 inline-block font-semibold stroke-2" />
                </a>
            </Paragraph>

            <SecondaryHeader id="stjohnscounty">Duval County Property Appraiser</SecondaryHeader>
            <Paragraph>
                <a
                    class="flex items-center ml-4"
                    href="https://www.jacksonville.gov/departments/property-appraiser"
                    target="_blank"
                    rel="noreferrer"
                >
                    St. Johns County Property Appraiser site
                    <ArrowTopRightOnSquareIcon class="h-4 w-4 ml-1 inline-block font-semibold stroke-2" />
                </a>
            </Paragraph>

            <SecondaryHeader id="stjohnscounty">Clay County Property Appraiser</SecondaryHeader>
            <Paragraph>
                <a class="flex items-center ml-4" href="https://www.ccpao.com/" target="_blank" rel="noreferrer">
                    St. Johns County Property Appraiser site
                    <ArrowTopRightOnSquareIcon class="h-4 w-4 ml-1 inline-block font-semibold stroke-2" />
                </a>
            </Paragraph>
        </BasicContainer>
    </PageContent>
</template>
<script setup>
import HomeLayout from "../Layouts/HomeLayout.vue";
import PageContent from "../Components/Layout/PageContent.vue";
import BasicContainer from "../Components/PageContent/Containers/BasicContainer.vue";
import { Head, Link, usePage } from "@inertiajs/vue3";
import { InformationCircleIcon, ArrowTopRightOnSquareIcon } from "@heroicons/vue/24/outline";
import Breadcrumbs from "../Components/PageContent/Breadcrumbs.vue";
import MainHead from "@/Components/PageContent/MainHead.vue";
import Paragraph from "@/Components/PageContent/Paragraph.vue";
import SecondaryHeader from "@/Components/PageContent/SecondaryHeader.vue";

defineOptions({ layout: HomeLayout });
const page = usePage();
const props = defineProps({
    title: {
        type: String,
        required: true,
    },
});
</script>
